import React from 'react';
import { CircleAlert } from 'lucide-react';

/**
 * The one error box above a submit button: what the whole form got wrong (the API said no, the
 * network is down). A mistake in a single field belongs under that field (AuthField `error`).
 * Announced as soon as it appears; `id` lets the fields point at it with aria-describedby.
 * Renders nothing without a message.
 */
function AuthAlert({ id, children }) {
  if (!children) return null;
  return (
    <div id={id} className="auth-error" role="alert">
      <CircleAlert size={16} aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}

export default AuthAlert;
